'use strict';
/*jshint unused:false*/
window.irxConfigSub = {
    web: {
        loginEndpoints: {
            ingenioEndpoint: 'https://secure.' + 'carelonrx.com' + '/member/dashboard'
        }
    },
    environment: 'prod1'
};
//# sourceMappingURL=config.prod1.js.map